// Conditional display for variant options.
// Shows the "Frame Color" option only when the "Framing" option is a wood selection.
// Automatically selects "Unframed Color" when unframed options are selected.

function getOptionContainers(variantPicker) {
  const optionNodes = Array.from(
    variantPicker.querySelectorAll('[data-option-name]')
  );
  const byName = {};
  optionNodes.forEach((el) => {
    const name = (el.getAttribute('data-option-name') || '').trim().toLowerCase();
    if (!name) return;
    byName[name] = el;
  });
  return byName;
}

function getSelectedValue(optionContainer) {
  if (!optionContainer) return '';

  // Fieldset with radios
  const radio = optionContainer.querySelector('input[type="radio"]:checked');
  if (radio) return (radio.value || '').trim();

  // Dropdown
  const select = optionContainer.querySelector('select');
  if (select) {
    const opt = select.options[select.selectedIndex];
    return (opt?.text || opt?.value || '').trim();
  }
  return '';
}

function shouldShowFrameColor(framingValue) {
  const v = (framingValue || '').toLowerCase();
  // Support variations such as "Wood Framed Canvas", "Wooden Canvas", "Wood Frame", etc.
  return v.includes('wood');
}

function isUnframed(framingValue) {
  const v = (framingValue || '').toLowerCase();
  return v.includes('unframed');
}

function updateVisibility(variantPicker) {
  const options = getOptionContainers(variantPicker);
  const framing = options['framing'];
  const frameColor = options['frame color'];
  const unframedColor = options['unframed color'];
  
  // Always hide the "Unframed Color" option from view
  if (unframedColor) {
    unframedColor.setAttribute('hidden', '');
    unframedColor.style.display = 'none';
    unframedColor.setAttribute('aria-hidden', 'true');
  }

  if (!framing) return;

  const framingValue = getSelectedValue(framing);
  const showFrameColor = shouldShowFrameColor(framingValue);
  const isUnframedOption = isUnframed(framingValue);

  // Handle Frame Color visibility
  if (frameColor) {
    if (showFrameColor) {
    frameColor.removeAttribute('hidden');
    frameColor.style.display = '';
    frameColor.setAttribute('aria-hidden', 'false');
      // Re-enable frame color inputs when shown
      const frameColorInputs = frameColor.querySelectorAll('input[type="radio"], select');
      frameColorInputs.forEach(input => {
        input.disabled = false;
      });
      
      // Hide "Unframed Color" option value within Frame Color section when framed option is selected
      const allLabels = frameColor.querySelectorAll('label.variant-option__button-label');
      allLabels.forEach(label => {
        const input = label.querySelector('input[type="radio"]');
        if (input && input.value) {
          const value = (input.value || '').toLowerCase();
          if (value.includes('unframed')) {
            label.style.display = 'none';
            label.setAttribute('aria-hidden', 'true');
          } else {
            label.style.display = '';
            label.removeAttribute('aria-hidden');
          }
        }
      });
      
      // Also handle select dropdowns
      const frameColorSelects = frameColor.querySelectorAll('select');
      frameColorSelects.forEach(select => {
        Array.from(select.options).forEach(option => {
          const value = (option.value || option.text || '').toLowerCase();
          if (value.includes('unframed')) {
            option.style.display = 'none';
            option.hidden = true;
          } else {
            option.style.display = '';
            option.hidden = false;
          }
        });
      });
  } else {
      // When hiding frame color (unframed option selected), uncheck and disable inputs
      // This prevents them from being included in variant picker's selectedOptionsValues
    frameColor.setAttribute('hidden', '');
    frameColor.style.display = 'none';
    frameColor.setAttribute('aria-hidden', 'true');
      const frameColorInputs = frameColor.querySelectorAll('input[type="radio"]:checked, select');
      frameColorInputs.forEach(input => {
        if (input instanceof HTMLInputElement) {
          input.checked = false; // Uncheck the radio button
          input.disabled = true;
        } else if (input instanceof HTMLSelectElement) {
          input.disabled = true;
        }
      });
    }
  }
}

function ensureUnframedColorSelected(variantPicker, options) {
  const framing = options['framing'];
  const unframedColor = options['unframed color'];
  const frameColor = options['frame color'];
  
  if (!framing || !unframedColor) return false;
  
  const framingValue = getSelectedValue(framing);
  if (!isUnframed(framingValue)) return false;
  
  // Uncheck and disable frame color inputs
  if (frameColor) {
    const frameColorInputs = frameColor.querySelectorAll('input[type="radio"]:checked, select');
    frameColorInputs.forEach(input => {
      if (input instanceof HTMLInputElement) {
        input.checked = false;
        input.disabled = true;
      } else if (input instanceof HTMLSelectElement) {
        input.disabled = true;
      }
    });
  }
  
  // Select unframed color
  const radios = unframedColor.querySelectorAll('input[type="radio"]');
  const select = unframedColor.querySelector('select');
  
  if (radios.length > 0) {
    // Check if already selected
    const alreadySelected = Array.from(radios).find(r => r.checked);
    if (alreadySelected) {
      return true; // Already selected
    }
    
    const firstAvailable = Array.from(radios).find(r => {
      const available = r.getAttribute('data-option-available');
      return available !== 'false';
    }) || radios[0];
    
    if (firstAvailable) {
      firstAvailable.checked = true;
      if (variantPicker.updateSelectedOption) {
        variantPicker.updateSelectedOption(firstAvailable);
      }
      console.log('✅ Selected Unframed Color:', firstAvailable.value);
      return true;
    } else {
      console.warn('⚠️ No available Unframed Color option found');
    }
  } else if (select) {
    const selectOptions = Array.from(select.options);
    const unframedOption = selectOptions.find(opt => {
      const text = (opt.text || opt.value || '').toLowerCase();
      return text.includes('unframed');
    });
    if (unframedOption) {
      if (select.selectedIndex === unframedOption.index) {
        return true; // Already selected
      }
      select.selectedIndex = unframedOption.index;
      console.log('✅ Selected Unframed Color:', unframedOption.text);
      return true;
    } else {
      console.warn('⚠️ No Unframed Color option found in select dropdown');
    }
  } else {
    console.warn('⚠️ Unframed Color option container found but no inputs/selects');
  }
  
  return false;
}

function initConditionalVariants(root = document) {
  const pickers = Array.from(root.querySelectorAll('variant-picker'));
  pickers.forEach((picker) => {
    const options = getOptionContainers(picker);
    const framing = options['framing'];
    const unframedColor = options['unframed color'];
    
    // Check if unframed color option exists
    if (!unframedColor) {
      console.warn('⚠️ "Unframed Color" option not found in product. Please add this option in Shopify admin.');
    }
    
    // Initial update and check if unframed or framed option is already selected
    updateVisibility(picker);
    if (framing) {
      const framingValue = getSelectedValue(framing);
      const frameColor = options['frame color'];
      
      if (shouldShowFrameColor(framingValue)) {
        // When a framed option is selected on initial load, ALWAYS select "Oak" as default
        if (frameColor) {
          // Uncheck any currently selected frame color (we always want Oak)
          const currentlySelected = frameColor.querySelector('input[type="radio"]:checked');
          if (currentlySelected && !currentlySelected.value.toLowerCase().includes('oak')) {
            currentlySelected.checked = false;
          }
          
          // Also uncheck select dropdowns if not Oak
          const frameColorSelects = frameColor.querySelectorAll('select');
          frameColorSelects.forEach(select => {
            const selectedOption = select.options[select.selectedIndex];
            if (selectedOption) {
              const value = (selectedOption.value || selectedOption.text || '').toLowerCase();
              if (!value.includes('oak')) {
                selectedOption.removeAttribute('selected');
              }
            }
          });
          
          // Check if Oak is already selected
          const oakAlreadySelected = frameColor.querySelector('input[type="radio"][value*="Oak" i]:checked') ||
                                    frameColor.querySelector('input[type="radio"][value*="oak"]:checked');
          
          // Only auto-select Oak if it's not already selected
          if (!oakAlreadySelected) {
            const allFrameColorInputs = frameColor.querySelectorAll('input[type="radio"]');
            let oakInput = null;
            
            allFrameColorInputs.forEach(input => {
              const value = (input.value || '').toLowerCase();
              // Also check the label text in case it's different from the value
              const label = input.closest('label');
              const labelText = label ? (label.textContent || label.innerText || '').toLowerCase() : '';
              
              if ((value === 'oak' || value.includes('oak') || labelText.includes('oak')) && 
                  !value.includes('unframed') && !labelText.includes('unframed')) {
                const available = input.getAttribute('data-option-available');
                if (available !== 'false') {
                  input.checked = true;
                  oakInput = input;
                }
              }
            });
            
            // Also handle select dropdowns
            frameColorSelects.forEach(select => {
              const selectOptions = Array.from(select.options);
              const oakOption = selectOptions.find(opt => {
                const value = (opt.value || opt.text || '').toLowerCase();
                return (value === 'oak' || value.includes('oak')) && !value.includes('unframed');
              });
              if (oakOption) {
                select.selectedIndex = oakOption.index;
                oakOption.setAttribute('selected', 'selected');
                selectOptions.forEach(opt => {
                  if (opt !== oakOption) {
                    opt.removeAttribute('selected');
                  }
                });
                oakInput = select;
              }
            });
            
            // Update variant picker state and trigger change if we selected Oak
            if (oakInput) {
              if (typeof picker.updateSelectedOption === 'function') {
                picker.updateSelectedOption(oakInput);
              }
              setTimeout(() => {
                if (oakInput instanceof HTMLElement) {
                  oakInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }, 0);
            }
          }
        }
      } else if (isUnframed(framingValue)) {
        // Handle unframed option on initial load
        if (frameColor) {
          // Uncheck all frame colors
          const allFrameColorInputs = frameColor.querySelectorAll('input[type="radio"]');
          allFrameColorInputs.forEach(input => {
            if (input.checked && !input.value.toLowerCase().includes('unframed')) {
              input.checked = false;
            }
          });
          
          // Find and select "Unframed Color" within Frame Color field
          const unframedColorInFrameColor = frameColor.querySelectorAll('label.variant-option__button-label');
          unframedColorInFrameColor.forEach(label => {
            const input = label.querySelector('input[type="radio"]');
            if (input && input.value) {
              const value = (input.value || '').toLowerCase();
              if (value.includes('unframed')) {
                input.checked = true;
                setTimeout(() => {
                  input.dispatchEvent(new Event('change', { bubbles: true }));
                }, 0);
              }
            }
          });
        }
        
        // Also check if "Unframed Color" is a separate option field
        if (unframedColor) {
          const success = ensureUnframedColorSelected(picker, options);
          if (success) {
            // Trigger change event to update variant picker with correct variant
            const radios = unframedColor.querySelectorAll('input[type="radio"]:checked');
            const select = unframedColor.querySelector('select');
            if (radios.length > 0) {
              setTimeout(() => {
                radios[0].dispatchEvent(new Event('change', { bubbles: true }));
              }, 0);
            } else if (select) {
              setTimeout(() => {
                select.dispatchEvent(new Event('change', { bubbles: true }));
              }, 0);
            }
          }
        }
      }
    }
    
    // Listen to framing changes in capture phase (before variant picker processes)
    if (framing) {
      framing.addEventListener('change', (event) => {
        const framingValue = getSelectedValue(framing);
        const frameColor = options['frame color'];
        
        if (shouldShowFrameColor(framingValue)) {
          // When a framed option is selected (like "Wood Framed Canvas"), select "Oak" as default
          if (frameColor) {
            // First, uncheck any unframed color that might be selected
            const allFrameColorInputs = frameColor.querySelectorAll('input[type="radio"]');
            allFrameColorInputs.forEach(input => {
              const value = (input.value || '').toLowerCase();
              if (value.includes('unframed')) {
                input.checked = false;
              }
            });
            
            // Uncheck any currently selected frame color (we always want Oak)
            const currentlySelected = frameColor.querySelector('input[type="radio"]:checked');
            if (currentlySelected) {
              currentlySelected.checked = false;
            }
            
            // Also uncheck select dropdowns
            const frameColorSelects = frameColor.querySelectorAll('select');
            frameColorSelects.forEach(select => {
              const selectedOption = select.options[select.selectedIndex];
              if (selectedOption) {
                selectedOption.removeAttribute('selected');
              }
            });
            
            // Select Oak SYNCHRONOUSLY (before variant picker processes framing change)
            // Check both input value and label text to find Oak
            let oakInput = null;
            allFrameColorInputs.forEach(input => {
              const value = (input.value || '').toLowerCase();
              // Also check the label text in case it's different from the value
              const label = input.closest('label');
              const labelText = label ? (label.textContent || label.innerText || '').toLowerCase() : '';
              
              if ((value === 'oak' || value.includes('oak') || labelText.includes('oak')) && 
                  !value.includes('unframed') && !labelText.includes('unframed')) {
                const available = input.getAttribute('data-option-available');
                if (available !== 'false') {
                  input.checked = true;
                  input.disabled = false;
                  oakInput = input;
                }
              }
            });
            
            // Also try select dropdowns
            frameColorSelects.forEach(select => {
              const selectOptions = Array.from(select.options);
              const oakOption = selectOptions.find(opt => {
                const value = (opt.value || opt.text || '').toLowerCase();
                return (value === 'oak' || value.includes('oak')) && !value.includes('unframed');
              });
              if (oakOption) {
                select.selectedIndex = oakOption.index;
                oakOption.setAttribute('selected', 'selected');
                selectOptions.forEach(opt => {
                  if (opt !== oakOption) {
                    opt.removeAttribute('selected');
                  }
                });
                oakInput = select;
              }
            });
            
            // Update variant picker's internal state so it tracks Oak as selected
            if (oakInput && typeof picker.updateSelectedOption === 'function') {
              picker.updateSelectedOption(oakInput);
            }
            
            // Trigger change event on Oak to ensure variant picker processes it
            if (oakInput) {
              setTimeout(() => {
                if (oakInput instanceof HTMLElement) {
                  oakInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }, 0);
            }
            
            // Also set up polling as backup in case the immediate selection didn't work
            const selectedNow = !!oakInput;
            
            // Continue with polling as backup (reduced attempts since we try immediately)
            if (!selectedNow) {
              // Use polling to check and select Oak after variant picker updates
              let attempts = 0;
              const maxAttempts = 10; // Try for up to 1 second (10 * 100ms)
              
              const trySelectOak = () => {
                attempts++;
                
                // Re-get options after morph (DOM may have changed)
                const newOptions = getOptionContainers(picker);
                const newFrameColor = newOptions['frame color'];
                
                if (newFrameColor) {
                  // Uncheck any currently selected frame color (we always want Oak)
                  const currentlySelected = newFrameColor.querySelector('input[type="radio"]:checked');
                  if (currentlySelected && !currentlySelected.value.toLowerCase().includes('oak')) {
                    currentlySelected.checked = false;
                  }
                  
                  // Also uncheck select dropdowns if not Oak
                  const newFrameColorSelects = newFrameColor.querySelectorAll('select');
                  newFrameColorSelects.forEach(select => {
                    const selectedOption = select.options[select.selectedIndex];
                    if (selectedOption) {
                      const value = (selectedOption.value || selectedOption.text || '').toLowerCase();
                      if (!value.includes('oak')) {
                        selectedOption.removeAttribute('selected');
                      }
                    }
                  });
                  
                  // Try to find and select Oak
                  let oakInput = null;
                  const newFrameColorInputs = newFrameColor.querySelectorAll('input[type="radio"]');
                  
                  newFrameColorInputs.forEach(input => {
                    const value = (input.value || '').toLowerCase();
                    if ((value === 'oak' || value.includes('oak')) && !value.includes('unframed')) {
                      const available = input.getAttribute('data-option-available');
                      if (available !== 'false') {
                        input.checked = true;
                        input.disabled = false;
                        oakInput = input;
                      }
                    }
                  });
                  
                  // Also handle select dropdowns (reuse the same variable)
                  newFrameColorSelects.forEach(select => {
                    const selectOptions = Array.from(select.options);
                    const oakOption = selectOptions.find(opt => {
                      const value = (opt.value || opt.text || '').toLowerCase();
                      return (value === 'oak' || value.includes('oak')) && !value.includes('unframed');
                    });
                    if (oakOption && select.selectedIndex !== oakOption.index) {
                      select.selectedIndex = oakOption.index;
                      oakOption.setAttribute('selected', 'selected');
                      selectOptions.forEach(opt => {
                        if (opt !== oakOption) {
                          opt.removeAttribute('selected');
                        }
                      });
                      oakInput = select;
                    }
                  });
                  
                  // If we found and selected Oak, update variant picker and trigger change
                  if (oakInput) {
                    // Update variant picker's internal state if method exists
                    if (typeof picker.updateSelectedOption === 'function') {
                      picker.updateSelectedOption(oakInput);
                    }
                    
                    // Trigger change event on oak input
                    setTimeout(() => {
                      oakInput.dispatchEvent(new Event('change', { bubbles: true }));
                    }, 10);
                    
                    // Stop polling - we're done
                    return;
                  }
                }
                
                // If we haven't selected Oak yet and haven't exceeded max attempts, try again
                if (attempts < maxAttempts) {
                  setTimeout(trySelectOak, 100);
                }
              };
              
              // Start polling immediately (no delay since we already tried synchronously)
              setTimeout(trySelectOak, 50);
            }
          }
        } else if (isUnframed(framingValue)) {
          // CRITICAL: When switching to unframed, uncheck ALL frame colors and select unframed color
          // This handles the case where user was on "Wood Framed Canvas" with a frame color selected
          
          if (frameColor) {
            // Uncheck ALL frame color inputs (not just checked ones, to be safe)
            const allFrameColorInputs = frameColor.querySelectorAll('input[type="radio"]');
            allFrameColorInputs.forEach(input => {
              if (input.checked) {
                input.checked = false;
              }
              input.disabled = true;
            });
            
            // Also check if "Unframed Color" is a value within the "Frame Color" field
            const unframedColorInFrameColor = frameColor.querySelectorAll('label.variant-option__button-label');
            let unframedInput = null;
            
            unframedColorInFrameColor.forEach(label => {
              const input = label.querySelector('input[type="radio"]');
              if (input && input.value) {
                const value = (input.value || '').toLowerCase();
                if (value.includes('unframed')) {
                  // Found "Unframed Color" as a value within "Frame Color" field
                  input.checked = true;
                  input.disabled = false;
                  unframedInput = input;
                  console.log('✅ Selected Unframed Color from Frame Color field:', input.value);
                }
              }
            });
            
            // Also check select dropdowns
            const frameColorSelects = frameColor.querySelectorAll('select');
            frameColorSelects.forEach(select => {
              const options = Array.from(select.options);
              const unframedOption = options.find(opt => {
                const value = (opt.value || opt.text || '').toLowerCase();
                return value.includes('unframed');
              });
              if (unframedOption) {
                select.selectedIndex = unframedOption.index;
                unframedOption.setAttribute('selected', 'selected');
                // Unselect other options
                options.forEach(opt => {
                  if (opt !== unframedOption) {
                    opt.removeAttribute('selected');
                  }
                });
                unframedInput = select;
                console.log('✅ Selected Unframed Color from Frame Color select:', unframedOption.text);
              }
            });
            
            // Update variant picker's internal state if method exists
            if (unframedInput && typeof picker.updateSelectedOption === 'function') {
              picker.updateSelectedOption(unframedInput);
            }
            
            // Trigger change event on unframed color input so variant picker processes it
            if (unframedInput) {
              setTimeout(() => {
                unframedInput.dispatchEvent(new Event('change', { bubbles: true }));
              }, 0);
            }
          }
          
          // Also check if "Unframed Color" is a separate option field
          if (unframedColor) {
            const unframedRadios = unframedColor.querySelectorAll('input[type="radio"]');
            const unframedSelect = unframedColor.querySelector('select');
            
            let unframedInput = null;
            
            if (unframedRadios.length > 0) {
              const firstAvailable = Array.from(unframedRadios).find(r => {
                const available = r.getAttribute('data-option-available');
                return available !== 'false';
              }) || unframedRadios[0];
              
              if (firstAvailable) {
                firstAvailable.checked = true;
                unframedInput = firstAvailable;
                console.log('✅ Selected Unframed Color from separate field:', firstAvailable.value);
              }
            } else if (unframedSelect) {
              const selectOptions = Array.from(unframedSelect.options);
              const unframedOption = selectOptions.find(opt => {
                const text = (opt.text || opt.value || '').toLowerCase();
                return text.includes('unframed');
              });
              if (unframedOption) {
                unframedSelect.selectedIndex = unframedOption.index;
                unframedOption.setAttribute('selected', 'selected');
                unframedInput = unframedSelect;
                console.log('✅ Selected Unframed Color from separate select:', unframedOption.text);
              }
            }
            
            // Update variant picker's internal state if method exists
            if (unframedInput && typeof picker.updateSelectedOption === 'function') {
              picker.updateSelectedOption(unframedInput);
            }
            
            // Trigger change event on unframed color input so variant picker processes it
            if (unframedInput) {
              setTimeout(() => {
                unframedInput.dispatchEvent(new Event('change', { bubbles: true }));
              }, 0);
            }
          }
        }
      }, true); // Capture phase - runs before variant picker's handler
    }
    
    // Observe changes - ensure unframed color is selected after any change
    picker.addEventListener('change', () => {
      updateVisibility(picker);
      // After variant picker processes change, ensure unframed color is still selected if needed
      if (framing && unframedColor) {
        const framingValue = getSelectedValue(framing);
        if (isUnframed(framingValue)) {
          ensureUnframedColorSelected(picker, options);
        }
      }
    });
    
    // Also react when variant-picker re-morphs after fetch
    const observer = new MutationObserver(() => {
      // Re-get options after morphing (DOM has changed)
      const newOptions = getOptionContainers(picker);
      const newFraming = newOptions['framing'];
      const newUnframedColor = newOptions['unframed color'];
      const newFrameColor = newOptions['frame color'];
      
      updateVisibility(picker);
      
      // Re-check after morphing
      if (newFraming) {
        const framingValue = getSelectedValue(newFraming);
        
        if (shouldShowFrameColor(framingValue)) {
          // When a framed option is selected, ensure Oak is selected after morphing
          if (newFrameColor) {
            // Uncheck any non-Oak frame color
            const currentlySelected = newFrameColor.querySelector('input[type="radio"]:checked');
            if (currentlySelected && !currentlySelected.value.toLowerCase().includes('oak')) {
              currentlySelected.checked = false;
            }
            
            // Check if Oak is already selected
            const oakSelected = newFrameColor.querySelector('input[type="radio"][value*="Oak" i]:checked') ||
                              newFrameColor.querySelector('input[type="radio"][value*="oak"]:checked');
            
            // Select Oak if not already selected
            if (!oakSelected) {
              const allFrameColorInputs = newFrameColor.querySelectorAll('input[type="radio"]');
              let oakInput = null;
              
              allFrameColorInputs.forEach(input => {
                const value = (input.value || '').toLowerCase();
                // Also check the label text in case it's different from the value
                const label = input.closest('label');
                const labelText = label ? (label.textContent || label.innerText || '').toLowerCase() : '';
                
                if ((value === 'oak' || value.includes('oak') || labelText.includes('oak')) && 
                    !value.includes('unframed') && !labelText.includes('unframed')) {
                  const available = input.getAttribute('data-option-available');
                  if (available !== 'false') {
                    input.checked = true;
                    oakInput = input;
                  }
                }
              });
              
              // Also handle select dropdowns
              const newFrameColorSelects = newFrameColor.querySelectorAll('select');
              newFrameColorSelects.forEach(select => {
                const selectOptions = Array.from(select.options);
                const oakOption = selectOptions.find(opt => {
                  const value = (opt.value || opt.text || '').toLowerCase();
                  return (value === 'oak' || value.includes('oak')) && !value.includes('unframed');
                });
                if (oakOption) {
                  select.selectedIndex = oakOption.index;
                  oakOption.setAttribute('selected', 'selected');
                  selectOptions.forEach(opt => {
                    if (opt !== oakOption) {
                      opt.removeAttribute('selected');
                    }
                  });
                  oakInput = select;
                }
              });
              
              // Update variant picker and trigger change if we selected Oak
              if (oakInput) {
                if (typeof picker.updateSelectedOption === 'function') {
                  picker.updateSelectedOption(oakInput);
                }
                requestAnimationFrame(() => {
                  if (oakInput instanceof HTMLElement) {
                    oakInput.dispatchEvent(new Event('change', { bubbles: true }));
                  }
                });
              }
            }
          }
        } else if (isUnframed(framingValue)) {
          // First, handle "Unframed Color" as a value within "Frame Color" field
          if (newFrameColor) {
            // Uncheck all frame colors
            const allFrameColorInputs = newFrameColor.querySelectorAll('input[type="radio"]');
            allFrameColorInputs.forEach(input => {
              if (input.checked && !input.value.toLowerCase().includes('unframed')) {
                input.checked = false;
              }
            });
            
            // Find and select "Unframed Color" within Frame Color field
            const unframedColorInFrameColor = newFrameColor.querySelectorAll('label.variant-option__button-label');
            unframedColorInFrameColor.forEach(label => {
              const input = label.querySelector('input[type="radio"]');
              if (input && input.value) {
                const value = (input.value || '').toLowerCase();
                if (value.includes('unframed')) {
                  input.checked = true;
                  requestAnimationFrame(() => {
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                  });
                }
              }
            });
          }
          
          // Also check if "Unframed Color" is a separate option field
          if (newUnframedColor) {
            // Ensure frame colors are unchecked
            if (newFrameColor) {
              const frameColorInputs = newFrameColor.querySelectorAll('input[type="radio"]:checked');
              frameColorInputs.forEach(input => {
                if (!input.value.toLowerCase().includes('unframed')) {
                  input.checked = false;
                  input.disabled = true;
                }
              });
            }
            
            // Re-select unframed color
            const success = ensureUnframedColorSelected(picker, newOptions);
            if (success) {
              // Trigger change to update variant picker
              const radios = newUnframedColor.querySelectorAll('input[type="radio"]:checked');
              const select = newUnframedColor.querySelector('select');
              if (radios.length > 0) {
                requestAnimationFrame(() => {
                  radios[0].dispatchEvent(new Event('change', { bubbles: true }));
                });
              } else if (select) {
                requestAnimationFrame(() => {
                  select.dispatchEvent(new Event('change', { bubbles: true }));
                });
              }
            }
          }
        }
      }
    });
    observer.observe(picker, { childList: true, subtree: true });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initConditionalVariants());
} else {
  initConditionalVariants();
}

